import './form-quote-accommodation.scss';

import { QuoteAccommodationFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = QuoteAccommodationFormSchema;
export function FormQuoteAccommodation() {
  const { control } = useFormContext<QuoteAccommodationFormSchema>();
  return (
    <div id="FormQuoteAccommodation" className="quote-accommodation">
      <InputControl<InputFormSchema>
        control={control}
        name="quotation"
        label="Quotation"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter quotation"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="hotel"
        label="Hotel"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter hotel"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="roomType"
        label="Room Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter roomType"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="numPeople"
        label="Num People"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter numPeople"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="unit"
        label="Unit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter unit"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="validFrom"
        label="Valid From"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validFrom"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="validUntil"
        label="Valid Until"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validUntil"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="price"
        label="Price"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter price"
      />
    </div>
  );
}

export default FormQuoteAccommodation;